export default {
    'name': 'burger',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M3 4.25C2.44772 4.25 2 4.69772 2 5.25C2 5.80228 2.44772 6.25 3 6.25H20.875C21.4273 6.25 21.875 5.80228 21.875 5.25C21.875 4.69772 21.4273 4.25 20.875 4.25H3ZM3 10.75C2.44772 10.75 2 11.1977 2 11.75C2 12.3023 2.44772 12.75 3 12.75H20.875C21.4273 12.75 21.875 12.3023 21.875 11.75C21.875 11.1977 21.4273 10.75 20.875 10.75H3ZM2 18.25C2 17.6977 2.44772 17.25 3 17.25H20.875C21.4273 17.25 21.875 17.6977 21.875 18.25C21.875 18.8023 21.4273 19.25 20.875 19.25H3C2.44772 19.25 2 18.8023 2 18.25Z\' fill=\'#FF4171\'/>'
}
